export const NOTIFICATIONS_ERROR = "notificationError";
export const NOTIFICATIONS_SUCCESS = "notificationSuccess";


export const EVENT_TRIGGER_IN_DEPTH_BET_CARD = 'triggerInDepthBetCard';
export const EVENT_UPDATE_IN_DEPTH_BET_CARD = 'updateInDepthBetCard';
export const EVENT_UPDATE_IN_DEPTH_BET_ID = 'updateInDepthBetId';
export const EVENT_UPDATE_ACTION_BAR_VIEW = 'updateActionBarView';
export const EVENT_UPDATE_PREV_VIEW = 'updatePrevView';
export const EVENT_NOTIFICATION_PUSH = 'notificationPush';
export const EVENT_FEED_LOCKED = 'feedLocked';
export const EVENT_UPDATE_AUTHENTICATED = 'updateAuthenticated';
export const EVENT_TRIGGER_REGISTRATION_MODAL = 'triggerRegistrationModal';
export const EVENT_TRIGGER_BET_CART = 'triggerBetCart';
export const EVENT_BET_CART_UPDATED = 'betCartUpdated';

// Ad-related constants
export const AD_INJECTION_INTERVAL = 10; // Inject ad every 5 bet cards
export const AD_CARDS_PER_PAGE = 25; // Total cards per page including ads
export const AD_CLICK_EVENT = 'adClick';
export const AD_CTA_CLICK_EVENT = 'adCtaClick';
export const LOGGED_OUT_VISIBLE_CARD_LIMIT = 3;

const DEFAULT_SPORTS = [
    'nba',
    'nfl',
    'cfb',
    'ncaab',
    'mlb',
    'nhl',
    'mma',
    'soccer',
    'wnba'
    ]

export const getDefaultSports = () => {
    return DEFAULT_SPORTS;
}
